jQuery.feature_import("js-order-assortment-clients",
    () => require("./OrderAssortmentClients.jsx"),
    mod => mod.feature_js_order_assortment_clients
);